import {
  AccountReferenceFilter,
  SessionStatusFilter,
  accountReferenceFilterSchema,
  sessionStatusFilterSchema,
} from 'simInventory/models/SimProfile.model';
import { SESSION_STATUS } from 'simInventory/utils/sessionStatus';

export const parseSessionStatus = (sessionStatus: string | null): SessionStatusFilter => {
  if (sessionStatus === null) {
    return SESSION_STATUS.UNKNOWN;
  }

  try {
    return sessionStatusFilterSchema.parse(sessionStatus);
  } catch {
    return SESSION_STATUS.UNKNOWN;
  }
};

export const parsedAccountReference = (accountReference: string | null): AccountReferenceFilter => {
  if (accountReference === null) {
    return '';
  }

  const parsedAccountReference = Number.parseInt(accountReference);
  if (Number.isNaN(parsedAccountReference)) {
    return '';
  }

  try {
    return accountReferenceFilterSchema.parse(parsedAccountReference);
  } catch {
    return '';
  }
};
